import axios from "../../plugins/axios";
import utils from "../../../utils/utils2"; //避免与utils交叉引用

// 库存模块
class Inventory {
    // getAllFactory(body) {
    //     return axios.post(`/myUserApp/service.AdProvider/CreateOne`, body)
    // }

    //-------------------------------库位管理--------------------------//
    //INTF-00063:保存新建的库位数据
    createWarehouse(body) {
        return axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/CreateOne`, body);
    }

    //INTF-00064:删除草稿库位
    batchWarehouseDelete(body) {
        return axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/Delete`, body);
    }

    //INTF-00065:修改库位信息
    updateWarehouse(body) {
        return axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/UpdateDetails`, body);
    }

    //INTF-00066: 分页显示所有的库位列表
    async getWarehouseList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.warehouse_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get warehouse list in pages failed: INTF-00066", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00185：批量禁用启用库位
    batchWarehouseEnableOrDisable(body) {
        return axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/UpdateActived`, body);
    }

    //INTF-00198：不分页获取库位列表
    async getAllWarehouseList() {
        let body = {};
        try {
            let res = await axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/FindAvailableNoLimit`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.warehouse_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get all warehouse list in no page failed: INTF-00198", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00234：根据请求的ID，返回该ID的库位的详细信息
    getWarehouseDetail(id) {
        let body = { id: id };
        return axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/FindOne`, body);
    }

    //INTF-00337：根据请求的根库位ID，获取其下的子位置信息
    async getChildLocationByRootWhId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myOrganizationApp/service.warehouse.WareHouseProvider/FindDescendants`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.warehouse_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get child location by root warehouse id failed: INTF-00337", err);
            return { err: true, msg: err.response.data };
        }
    }

    //--------------批次序列号-------------------------------------//
    //INTF-00074：对新建的批次序列号进行保存
    createTrace(body) {
        return axios.post(`/myMaterialApp/service.TraceProvider/CreateOne`, body);
    }

    //INTF-00075：删除草稿数据
    deleteTrace(body) {
        return axios.post(`/myMaterialApp/service.TraceProvider/Delete`, body);
    }

    //INTF-00076:对已有批次序列号进行修改保存
    updateTrace(body) {
        return axios.post(`/myMaterialApp/service.TraceProvider/UpdateDetails`, body);
    }

    //INTF-00077:分页查询批次序列号列表
    async getTraceList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myMaterialApp/service.TraceProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.trace_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get trace list failed: INTF-00077", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00396：根据物料号、库存位置，返回其在该位置下的批次、数量（在手数、可用数）列表（不分页）
    async getTraceListByMaterialAndLocationId(mid, lid) {
        let body = { material_id: mid, warehouse_id: lid };
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockQuantityProvider/FindAllByMaterial`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_quantity_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get trace list by material and location id failed: INTF-00396", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00426：获取不分页的，可用的批次或序列号。
    async getAvailableTraceList() {
        let body = {};
        try {
            let res = await axios.post(`/myMaterialApp/service.TraceProvider/FindAllAvailable`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.trace_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get all available trace list failed: INTF-00426", err);
            return { err: true, msg: err.response.data };
        }
    }

    //----------------------库存查询-----------------------//
    //INTF-00073：分页查询库存列表
    async getStock(query) {
        let body = { query: query };
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockQuantityProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_quantity_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get stock info failed: INTF-00073", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00487：查询库存移动明细，分页、可日期
    async getStockMoveByDateInPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockQuantityProvider/FindAllDetails`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_quantity_records = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get stock move list by date in pages failed: INTF-00487", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00605：基于某一日的库存分页查询
    async getStockInDateInpage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockQuantityProvider/FindAllForOneDay`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_quantity_records = [];
                res.total = 0;
            }
            return res;

        } catch (err) {
            console.log("get stock in date in pages failed: INTF-00605", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00623：查询某一日的库存价值，获得其CSV格式文件的下载链接
    getStockValueFile(query) {
        let body = query;
        return axios.post(`/myStockMoveApp/service.StockQuantityProvider/FindPriceForOneDay`, body);
    }

    //INTF-00756：下载库存移动类型=2，5，6，7，14的库存单明细
    batchDownloadStockMove(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/Download`, body);
    }

    //--------------------------库存调拨移动单头相关--------------------------------//
    //INTF-00068：对新建的库存移动单头进行保存
    addMoveHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/CreateOne`, body);
    }

    //INTF-00069：删除选中的库存移动单
    batchMoveHeaderDelete(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/Delete`, body);
    }

    //INTF-00070：对编辑的库存移动单头进行修改
    modifyMoveHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00072：分页查询获取库存移动单列表
    async getMoveHeaderList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get move header list failed: INTF-00072", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00287：根据调拨单ID，获取调拨单头的详细信息
    getDetailByMoveHeaderId(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindOne`, body);
    }

    //INTF-00334：对选中的移动单头进行生失效更改。arr是选中的id数组，x=1，设置成生效，2设置成失效。
    batchMoveHeaderEnableOrDisable(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/UpdateActived`, body);
    }

    //INTF-00451：根据采购订单行或销售订单行ID、需要查询的移动类型，返回该订单行关联的库存移动单头列表
    async getMoveHeadersByMoveTypeAndLineId(id, arr) {
        let body = { line_id: id, move_type: arr };
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindAllByPO`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get move header list by move type and po line id failed: INTF-00451", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00482：带限制条件的分页查询：分页可搜索的，未关联客户收货单的销售出库单头列表。用于创建客户收货单时选择
    async getUnReceivedMoveHeaderListForSale(query) {
        let body = { query: query };
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindAvailablForCR`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get unreceived move header list for sale failed: INTF-00482", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00483：根据销售订单行ID，需要查询的移动类型，返回该订单行关联的库存移动单头列表
    getMoveHeadersByMoveTypeBySoId(id, arr, route) {
        let body = { types: "object,object", values: [{ po_line_id: id, move_type: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

    //INTF-00484：根据销售订单行id，查询获得不分页的客户收货单列表
    async getCustomerReceiverHeader(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/FindAllBySO`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.customer_receipt_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get cr header list by line id failed: INTF-00484", err);
            return { err: true, msg: err.responsed.data };
        }
    }

    //INTF-00776：公司间交易用：获取本公司下，收到的对手公司的销售发货单据列表，分页。
    async getSaleSendListInPagesInCompany(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindDeliveredHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.delivered_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get sale send list in pages in company failed: INTF-00776", err);
            return { err: true, msg: err.response.data };
        }

    }

    //---------------------------库存移动明细相关----------------------------//
    //INTF-00071：保存一条移动明细行
    addMoveLine(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.StockMoveLineProvider/CreateOne`, body);
    }

    /*INTF-00221：根据采购订单ID，在库存移动单id下，创建该采购订单中尚未完成收货的订单明细信息。
    createUnreceivedMoveLineByPoId(body) {
        return axios.post(``, body);
    }

    //INTF-00224：根据销售订单ID，在库存移动单id下，创建该销售订单中尚未完成发货的订单明细信息。
    createUndeliveredMoveLineBySoId(body) {
        return axios.post(``, body);
    }
    */

    //INTF-00225：对修改的库存移动明细行进行保存
    updateMoveLine(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.StockMoveLineProvider/UpdateDetails`, body);
    }

    //INTF-00226：删除库存移动单下的移动明细行
    batchDeleteMoveLines(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myStockMoveApp/service.StockMoveLineProvider/Delete`, body);
    }



    //INTF-00227：根据库存移动单id，获得分页的移动明细行
    async getMoveLinesByMoveHeaderId(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveLineProvider/FindAllByHeaderId`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get move lines by move header failed: INTF-00227", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00458：根据移动单头+物料号 查询该源位置下所有库位中的该物料的所有可用数量
    async getAvailabeQtyByMoveHeaderIdAndMaterialId(move_header_id, material_id) {
        let body = { stock_header_id: move_header_id, material_id: material_id };
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveLineProvider/GetAllAvailableQuantity`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.quantity = 0;
            }
            return res;
        } catch (err) {
            console.log("get available qty by move header and material failed: INTF-00458", err);
            return { err: true, msg: err.response.data };
        }
    }


    //INTF-00788：针对销售出库的库存移动单据，批量保存一坨一坨的库存移动明细
    batchUpdateMoveLinesForMoveType3(header_id, arr) {
        let body = { stock_header_id: header_id, stock_line_infos: arr };
        return axios.post(`/myStockMoveApp/service.StockMoveLineProvider/BatchCreate`, body);
    }

    //------------------------作业详情相关-----------------------------//
    //INTF-00341：根据移动明细行ID，获得其操作明细列表
    async getMoveFinishLinesByMoveLineId(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myStockMoveApp/service.StockMoveDetailsProvider/FindAllByLine`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.stock_move_detail_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get move finish lines by move line id failed: INTF-00341", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00342：对移动明细行的操作完成详情列表进行更新保存
    updateMoveFinishLinesByMoveLineId(arr, id) {
        let body = { stock_move_detail_infos: arr, stock_line_id: id };
        return axios.post(`/myStockMoveApp/service.StockMoveDetailsProvider/UpdateSome`, body);
    }

    //INTF-00757：导入非销售出库类型的库存移动明细、作业详情
    batchImportMoveLinesAndDetailLines(dir, fileName, fileUid, id) {
        let body = { fileName: fileName, fileDir: dir, fileUid: fileUid, parameter: String(id) };
        return axios.post(`/myStockMoveApp/service.StockMoveLineProvider/ModuleFileImport`, body);
    }


    //------------------客户收货单相关-------------------------//
    //--------------------客户收货单头相关--------------//
    //INTF-00459：保存新建的客户收货单头
    addNewCustomerReceiveHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/CreateOne`, body);
    }

    //INTF-00460: 根据客户收货单头ID，获得客户收货单详情信息
    getCustomerReceiveHeaderDetailById(id) {
        let body = { id: id };
        return axios.post('/myStockMoveApp/service.CustomerReceiptHeaderProvider/FindOne', body);
    }

    //INTF-00464：对已创建的客户收货单头进行修改保存
    updateCustomerReceiveHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00465：根据销售出库单ID，获取其关联的客户收货单头信息
    getCustomerReceiveHeaderByMoveHeaderId(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/FindByStockMove`, body);
    }

    //INTF-00468：分页查询获取客户收货单列表
    async getCustomerReceiveHeaderInPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.customer_receipt_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get cr list in pages failed: INTF-00468", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00495：对选中的客户收货单进行删除
    batchDeleteCustomerReceiveHeaders(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/Delete`, body);
    }

    //INTF-00778：公司间交易用：根据买方的采购收货单的ids，创建卖方的客户收货单
    createCrByGrIdsInCrossTrade(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.CustomerReceiptHeaderProvider/CreateWithInternal`, body);
    }

    //------------------客户收货单明细行-----------------------//

    //INTF-00461：获取客户收货单头下的收货明细列表，分页
    async getReceiveListByHeaderId(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.CustomerReceiptLineProvider/FindAllByHeaderId`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.customer_receipt_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get receive list by header failed: INTF-00461", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00462：对修改的收货明细行的进行保存
    updateReceiveLine(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.CustomerReceiptLineProvider/UpdateDetails`, body);
    }


    //-----------------客户收货单中的差异明细行-------------------------//

    //INTF-00466：根据前端提供的收货明细行ID，不分页，查询其关联的差异处理明细行。若无差异明细行，返回空数组。
    async getDeviationLineById(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myStockMoveApp/service.ReceiptDeviationDetailsProvider/FindAllByLine`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.receipt_deviation_details_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get deviation line by id failed: INTF-00466", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00467：更新一条收货明细行关联的差异处理列表（一坨一起）
    updateDeviationLines(arr, id) {
        let body = { receipt_deviation_details_infos: arr, customer_receipt_line_id: id };
        return axios.post(`/myStockMoveApp/service.ReceiptDeviationDetailsProvider/UpdateSome`, body);
    }



    /*INTF-00469：删除选中的差异明细行，一坨一起更新，所以不需要了
    batchDeleteDeviationLines(arr, route) {
        let body = { types: "object,object", values: [{ idArr: arr }, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }
    */

    //INTF-00683：检查差异信息是否在关联的库存移动的作业详情内
    checkDeviationLineInfo(val, route) {
        let body = { types: "object,object", values: [val, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }


    //------------采购收货单相关-----------------------------//
    //---------------采购收货单头-------------------------------//
    //INTF-00493：查询获取分页的采购收货单头列表
    async getGRList(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.gr_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get GR list in pages failed: INTF-00493", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00494：对新建的采购收货单头进行保存
    addNewGRHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/CreateOne`, body);
    }

    //INTF-00494B：扫描收货整单提交（后端按ASN现值复核+原子建单，替代手动建单+逐行加行）
    submitScanReceive(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/SubmitScanReceive`, body);
    }

    //INTF-00496：对修改的采购收货单头进行保存
    updateGRHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00506：根据id，获得采购收货单详情
    getGRDetailById(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/FindOne`, body);
    }

    //INTF-00507：批量删除采购收货单
    batchDeleteGR(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/Delete`, body);
    }

    //INTF-00508：批量设置采购收货单的生失效
    batchDisableOrEnableGR(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/UpdateActived`, body);
    }

    //INTF-00519：根据采购订单行ID，获取其关联的采购收货单头列表。
    async getGRListByPoLineId(id, type_arr) {
        let body = { line_id: id, move_type: type_arr };
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/FindAllByPO`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.gr_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get gr list by po line failed: INTF-00519", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00540：根据采购收货单头id（外协采购收货），获取关联的子件消耗移动单头详情信息
    getConsumptionHeaderByGrId(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.StockMoveHeaderProvider/FindByGoodsReceive`, body);
    }


    //INTF-00775：公司间交易中，根据用户选中的对手公司的销售发货id,创建本公司的采购收货单草稿
    createGrBySaleSendIdInCrossTrade(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/CreateWithInternal`, body);
    }

    //INTF-00777：公司间交易中，分页获取公司下，买方公司完成了采购收货的单据列表
    async getGrListInPagesInCompanyInCrossTrade(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReceiveHeaderProvider/FindAllReceivedHeader`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.gr_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get gr list in pages in company failed: INTF-00777", err);
            return { err: true, msg: err.response.data };
        }
    }

    //------------------------采购收货单，明细行相关-----------------------------//

    //INTF-00497：对一条采购收货明细行的修改进行保存
    updateGRLine(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveLineProvider/UpdateDetails`, body);
    }


    //INTF-00498：根据采购收货单头ID，分页查询获取其下收货单明细行列表
    async getGRMoveLineById(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReceiveLineProvider/FindAllByHeaderId`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.goods_receive_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get GR move lines in pages failed: INTF-00498", err);
            return { err: true, msg: err.response.data };
        }
    }




    //INTF-00512：当采购收货是非ASN收货时，对新建的采购明细行进行保存
    addGRMoveLine(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveLineProvider/CreateOne`, body);
    }

    //INTF-00513：对选中的采购收货明细行进行删除
    batchDeleteGRMoveLine(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveLineProvider/Delete`, body);
    }
    //---------------------------采购收货单，明细行的作业详情相关------------------------//
    //INTF-00510：根据ID获得收货明细行的作业详情
    async getGRLineMoveDetailList(id) {
        let body = { id: id };
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReceiveDetailsProvider/FindAllByLine`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.goods_receive_details_info = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get GR line move detail list failed: INTF-00510", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00511：更新保存一个采购收货明细行的一坨作业详情列表
    updateGRDetailLines(arr, id) {
        let body = { goods_receive_details_info: arr, gr_line_id: id };
        return axios.post(`/myStockMoveApp/service.GoodsReceiveDetailsProvider/UpdateSome`, body);
    }

    //--------------------------采购退货相关----------------------------------------//
    //INTF-00608：查询获取分页的采购退货列表
    async getPurchaseReturnGoodsListInPage(query) {
        let body = { query: query };
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.goods_return_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get purchase return goods list in page failed: INTF-00608", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00609：对新建的采购退货单头进行保存
    addPurchaseReturnGoodHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/CreateOne`, body);
    }

    //INTF-00610：对已创建的采购退货进行修改保存
    updatePurchaseReturnGoodHeader(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/UpdateDetails`, body);
    }

    //INTF-00611：根据退货单ID，返回其详细信息
    getPurchaseReturnGoodHeaderDetailById(id) {
        let body = { id: id };
        return axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/FindOne`, body);
    }

    //INTF-00612：对选中的菜头退货单进行批量删除
    batchDeletePurchaseReturnGoodsList(arr) {
        let body = { id_arr: arr };
        return axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/Delete`, body);
    }

    //INTF-00613：批量设置采购退货的生失效
    batchEnableOrDisablePurchaseReturnGoods(arr, x) {
        let body = { id_arr: arr, if_actived: x };
        return axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/UpdateActived`, body);
    }

    //INTF-00614：在采购退货单头下，对一条退货行进行保存
    addPurchaseReturnGoodLine(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReturnLineProvider/CreateOne`, body);
    }

    //INTF-00615：在采购退货单头下，对一条退货行进行修改保存
    updatePurchaseReturnGoodLine(val) {
        let body = val;
        return axios.post(`/myStockMoveApp/service.GoodsReturnLineProvider/UpdateDetails`, body);
    }

    //INTF-00616：对选中的退货行进行批量删除
    batchDeletePurchaseReturnGoodLines(header_id, arr) {
        let body = { header_id: header_id, id_arr: arr };
        return axios.post(`/myStockMoveApp/service.GoodsReturnLineProvider/Delete`, body);
    }

    //INTF-00617：在一个采购退货头下，分页查询其下的退货行明细列表
    async getPurchaseReturnGoodLinesByHeaderIdInPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReturnLineProvider/FindAllByHeaderId`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.goods_return_line_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get purchase return goods lines in pages failed: INTF-00617", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00618：根据采购订单ID，分页查询其关联的所有有效且已发布的收货单行
    async getGRLinesByPoIdInPage(query) {
        let body = query;
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReceiveLineProvider/FindByPoHeaderId`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.infos = [];
                res.total = 0;
            }
            //如果infos有内容，还要检查returned_qty，如果是undefined，要补全
            let a = res.infos;
            if (a.length > 0) {
                a.forEach((item) => {
                    if (item.returned_qty === undefined) {
                        item.returned_qty = 0;
                    }
                });
            }
            return res;
        } catch (err) {
            console.log("get gr lines by po in pages failed: INTF-00618", err);
            return { err: true, msg: err.response.data };
        }
    }

    //INTF-00645：供应商页面中，获得该供应商的收到的退货头列表
    async getPurchaseReturnGoodHeaderInSupplierInpage(query) {
        let body = { query: query };
        try {
            let res = await axios.post(`/myStockMoveApp/service.GoodsReturnHeaderProvider/FindAll`, body);
            if (utils.isEmptyObject(res)) {
                //空对象，补全
                res.goods_return_header_infos = [];
                res.total = 0;
            }
            return res;
        } catch (err) {
            console.log("get purchase return goods list in supplier in pages failed: INTF-00645", err);
            return { err: true, msg: err.response.data };
        }
    }

    //-------------------------明细导出---------------------------//
    //INTF-00685：导出采购收货入库明细列表
    exportGrLines(query) {
        let body = query;
        return axios.post(`/myStockMoveApp/service.GoodsReceiveLineProvider/FindAll`, body);
    }

    //INTF-00686：导出客户收货入库明细列表
    exportCrLines(query) {
        let body = query;
        return axios.post(`/myStockMoveApp/service.CustomerReceiptLineProvider/FindAll`, body);
    }

    //INTF-00689：导出基于采购订单的应付预估明细
    exportEstimatedAPListBasePoInfos(query, route) {
        let body = { types: "object,object", values: [query, utils.getUidAndToken(route)] };
        return axios.post(`/xxl`, body);
    }

};

export default Inventory;